export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  ADMIN: '/admin',
  ADMIN_APP_VERSIONS: '/admin/app-versions',
  NOT_FOUND: '*',
} as const;
